export enum AccountDetailsTabs {
  Overview = 'overview',
  Wallets = 'wallets',
  Documents = 'documents',
  Onboarding = 'onboarding'
}
